<template>
  <div class="arrow">
    <section-heading>What The Colloquium IS and what it is NOT</section-heading>
    <div class="background--linearPosition">
      <div
        class="arrow__wrapper"
        v-for="(item, index) in textData"
        :key="index"
      >
        <div class="arrow__pointer arrow--gray">
          <div class="arrow__text">
            <h6 class="text--gray">{{ item.leftText }}</h6>
          </div>
        </div>
        <div class="arrow__pointer arrow--red">
          <div class="arrow__text">
            <h6 class="text--red">{{ item.rightText }}</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Heading from "../Shared/Heading";
export default {
  data() {
    return {
      textData: [
        {
          leftText: "Training Program, Seminar, Workshop",
          rightText: "Fool-proof Scientific System with a proven Framework",
        },
        {
          leftText: "Collecting more knowledge & awareness",
          rightText: "Hardcore Implementation using the Laws of Productivity",
        },
        {
          leftText: "Making you feel good",
          rightText: "Making you Accountable for your actions & results",
        },
        {
          leftText: "Telling you what to do",
          rightText: "Hand-holding you on what to do everyday",
        },
        {
          leftText: "Motivating you with stories of successful people",
          rightText: "Making You The Success Story to live a fuller life",
        },
      ],
    };
  },
  components: {
    "section-heading": Heading,
  },
};
</script>
<style scoped>
.arrow {
  margin-bottom: 50px;
}

.arrow__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
}

.arrow__wrapper:last-child {
  padding-bottom: 50px;
}

.arrow__pointer {
  width: 40%;
  height: 100px;
  position: relative;
}

.arrow__pointer:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
}

.arrow__pointer:before {
  content: "";
  position: absolute;
  right: -50px;
  bottom: 0;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
}

.arrow__pointer.arrow--gray {
  background: linear-gradient(to right, #b6b8ba, #dededf);
}

.arrow__pointer.arrow--red {
  background: linear-gradient(to right, #b61d23, #ed1c24);
}

.arrow__pointer.arrow--gray:before {
  border-left: 50px solid #dededf;
}

.arrow__pointer.arrow--gray:after {
  border-left: 50px solid white;
}

.arrow__pointer.arrow--red:before {
  border-left: 50px solid #ed1c24;
}

.arrow__pointer.arrow--red:after {
  border-left: 50px solid #dededf;
}

.arrow__text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

.arrow__text h6 {
  font-size: 22px;
  font-family: "Seravek-Light";
  margin-bottom: 0;
}

.arrow__text .text--gray {
  color: var(--text-color);
  text-decoration: line-through;
  text-decoration-color: var(--primary-color);
  padding-left: 70px;
}

.arrow__text .text--red {
  color: var(--secondary-color);
  padding-left: 70px;
  width: 80%;
}

.background--linearPosition {
  background-image: linear-gradient(
    to bottom,
    var(--secondary-color) 90%,
    var(--background-color)
  );
  background-color: var(--secondary-color);
}
/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 320px) and (max-width: 767px) {
  .arrow__wrapper {
    padding-top: 30px;
  }
  .arrow__text h6 {
    font-size: 18px;
  }
  .arrow__text .text--red {
    width: 90%;
  }
  .arrow__wrapper {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
  .arrow__pointer.arrow--red:after {
    border-left: 50px solid #fff;
  }
  .arrow__pointer.arrow--gray:after {
    border-left: 50px solid white;
  }
  .arrow__pointer {
    width: 75%;
    height: 100px;
    position: relative;
    margin-left: 30px;
  }
}

/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  .arrow__text h6{
    font-size: 20px;
  }
  .arrow__text .text--red{
    width: 90%;
  }
  
}
</style>